const storageKey = (userId: string) => `judi-deferred-list-invites:${userId}`;

function readIds(userId: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : [];
  } catch {
    return [];
  }
}

/** Every Invitation this person already chose "Decide later" on. */
export function listDeferredInvitations(userId: string): string[] {
  return readIds(userId);
}

/** True when this person already chose "Decide later" for this Invitation. */
export function isInvitationDeferred(userId: string, listId: string): boolean {
  return readIds(userId).includes(listId);
}

/** Remember that they will answer this Invitation from Settings instead. */
export function deferInvitation(userId: string, listId: string): void {
  const ids = readIds(userId);
  if (ids.includes(listId)) return;
  localStorage.setItem(storageKey(userId), JSON.stringify([...ids, listId]));
}
